import React, { Component } from 'react'
import { connect } from 'react-redux'
import { requireAuthentication } from '../helpers/authentication'
import {
  getUserIsLoading,
  getIsMoreUsersLoading,
  getUsersList,
} from '../selectors/users'
import { getIsExternalProvider } from '../selectors/user'
import { loadUsersList, loadMoreUsers } from '../thunks/users'
import Forbidden from '../components/Forbidden'
import MustHave from '../containers/MustHave'
import Loading from '../components/Loading'
import { UsersList } from '../components/Users/index'

class UserListContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      usersFetched: false,
    }
  }

  componentDidMount() {
    const { loadUsersList } = this.props
    loadUsersList().then(() => {
      this.setState({ usersFetched: true })
    })
  }
  render() {
    const { isLoading } = this.props
    if (isLoading && !this.state.usersFetched) {
      return <Loading />
    }

    return (
      <MustHave
        permission="page-user-administration:get"
        fallback={<Forbidden />}
      >
        <UsersList {...this.props} />
      </MustHave>
    )
  }
}

const mapState = (state) => {
  return {
    users: getUsersList(state),
    externalProvider: getIsExternalProvider(state),
    isLoading: getUserIsLoading(state),
    isMoreUsersLoading: getIsMoreUsersLoading(state),
  }
}

const mapDispatch = (dispatch) => {
  return {
    loadUsersList: (params) => dispatch(loadUsersList(params)),
    loadMoreUsers: (params) => dispatch(loadMoreUsers(params)),
  }
}

export default connect(
  mapState,
  mapDispatch,
)(requireAuthentication(UserListContainer))
